



























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import PagingUnit from '@/components/paging/paging.vue';
import { performanceServer } from '@/api/installServer';
import addACheckTemplate from './addACheckTemplate.vue';

@Component({
  components: { PagingUnit, addACheckTemplate },
})
export default class CheckRectification extends Vue {
  private boardName: any = '';
  private tableData: any = [];

  private queryDataForm: any = {
    pageNo: 1,
    pageSize: 10,
  };

  private total = 0;

  private pageIndex = 1;
  private editData: any = {}; //选中的单挑编辑项
  private currentType: any = ''; //判断当前点击的是新增还是删除按钮

  mounted() {
    this.currentType = '';
    this.getListData();
  }

  // 获取表格数据
  private async getListData() {
    const res = await performanceServer.getTheirList();

    if (res.code === '200') {
      console.log(res.data);

      this.tableData = res.data;
      // this.total = res.total;
    } else {
      this.$message.error(res.msg);
    }
    console.log(res);
  }

  // 查找
  private async findBoard() {
    if (this.boardName === '') {
      return this.$message.warning('请输入模板名称');
    }
    console.log(this.boardName);
    const res = await performanceServer.FindTheirList({
      name: this.boardName,
    });

    if (res.code === '200') {
      this.boardName = '';
      this.tableData = res.data;
      console.log(this.tableData);

      // this.total = res.total;
    } else {
      this.$message.error(res.msg);
    }
    // console.log(res);
  }

  // 编辑删除操作
  private operation(type: string, row: any) {
    if (type !== 'delete') {
      // console.log('编辑');
      this.editData = row;
      this.currentType = 'edit';
      // console.log(this.editData);
      this.pageIndex = 2;
    } else {
      // 点击 删除
      this.$confirm('此操作将永久删除该条数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          console.log('确认删除');
          performanceServer.deleteTheirList(row.id).then((res: any) => {
            if (res.code === '200') {
              this.$message.success('删除成功');
              this.getListData();
            } else {
              this.$message.error(res.msg);
              this.getListData();
            }
          });
        })
        .catch(() => {
          this.$message.info('已取消删除');
        });
    }
    // console.log(type, row);
  }
  // 分页选择
  public getRectifyForm() {
    this.getListData();
  }

  // 点击新增
  handleAdd() {
    this.pageIndex = 2;
    this.currentType = 'add';
  }
  // 新增模板成功
  addScuess() {
    // console.log('addScuess');
    this.pageIndex = 1;
    this.getListData();
  }
  // 子页面点击返回按钮
  back() {
    this.pageIndex = 1;
    this.getListData();
  }
}
